/* eslint-disable no-sequences */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import {
  BtnSave,
  ButtonClosed,
  Container,
  DivForm,
  DivInput,
  Form,
  Input,
  Label,
  Modal,
  Title,
} from './style'
import {
  ContainerTitle,
  DivTitle,
} from '../../../components/TitlePage/TitlePage'
import Close from '../../../assets/icons/close'
import { useUsers, papelMultiVendedor } from '../useUsers'
import { CpfsVendedores } from '../../../components/CpfsVendedores/CpfsVendedores'
import { formataCPF } from '../../../utils/cpfMask'

type EditarUsuarioOrgProps = {
  modal: () => void
  usuarioId: number
}

export function EditarUsuarioOrg({ modal, usuarioId }: EditarUsuarioOrgProps) {
  const {
    searchPapel,
    searchCpf,
    setSearchCpf,
    searchCpfs,
    setSearchCpfs,
    handleValidaEdicao,
    campoObrigatorioCpf,
    // campoPapel,
    handleChangeSelectUser,
  } = useUsers()
  return (
    <Container>
      <Modal>
        <DivTitle color="black" size={22}>
          <Title>
            <ContainerTitle>Editar usuário</ContainerTitle>
            <ButtonClosed type="button" onClick={modal}>
              <Close />
            </ButtonClosed>
          </Title>
        </DivTitle>
        <DivForm>
          <Form>
            <div>
              <Label integracao left="15px" htmlFor="papel">
                Papel
              </Label>
              <select
                value={searchPapel}
                onChange={handleChangeSelectUser}
                name=""
                id=""
              >
                <option value="ADMINISTRADOR">ADMINISTRADOR</option>
                <option value="COORDENADOR">COORDENADOR</option>
                <option value="ASSISTENTE">ASSISTENTE</option>
                <option value="VENDEDOR">VENDEDOR</option>
              </select>
              {/* <Input
                width="250px"
                type="text"
                value={searchPapel}
                onChange={event => setSearchPapel(event.target.value)}
                required
              />
              <DivInput>
                {campoPapel ? (
                  <span>*O campo papel deve ser ADMINISTRADOR ou VENDEDOR</span>
                ) : (
                  ''
                )}
              </DivInput> */}
            </div>
            <div>
              <Label integracao left="280px" htmlFor="cpf">
                CPF
              </Label>
              <Input
                integracao
                width="270px"
                type="text"
                value={searchPapel === 'VENDEDOR' ? formataCPF(searchCpf) : ' '}
                onChange={event => setSearchCpf(event.target.value)}
                required
                disabled={searchPapel !== 'VENDEDOR'}
              />
              <DivInput>
                {campoObrigatorioCpf ? (
                  <span>
                    *Informe ao menos um CPF válido (11 dígitos) para o papel
                    selecionado
                  </span>
                ) : (
                  ''
                )}
              </DivInput>
            </div>
          </Form>

          {/* PD-0004: coordenador e assistente acompanham varios vendedores. */}
          {papelMultiVendedor(searchPapel) && (
            <CpfsVendedores
              cpfs={searchCpfs}
              onChange={setSearchCpfs}
              idPrefix="editar"
            />
          )}

          <BtnSave
            type="button"
            onClick={() => {
              handleValidaEdicao(usuarioId, modal)
            }}
          >
            Salvar
          </BtnSave>
        </DivForm>
      </Modal>
    </Container>
  )
}
